<template>
  <a-modal
    :width="'91%'"
    :visible="visible"
    :confirmLoading="false"
    :destroyOnClose="true"
    :closable="false"
    :bodyStyle="bodyStyle"
    :dialog-style="{ top: '62px'}"
    @cancel="close"
    :zIndex="-1">
    <div>
      <div id='printDiv' ref='printDiv' style="padding-right: 20px">
        <div style="display: flex;align-items: center;justify-content: space-between" >
          <img src="../assets/img/mq_logo.png" style="width: 120px;height: 38px" />
          <div class="rep-title" style="position:absolute;left:50%;transform:translate(-50%);">动态血糖监测报告</div>
          <div style="display:flex">
            <div>
              <div style="display: flex;align-items: center">
                <div class="small-point"></div>
                <div style="margin-left: 8px" class="info-text">姓名：</div>
                <div class="info-text-1">{{basicInfo.name || '--'}}</div>
              </div>
              <div style="display: flex;align-items: center">
                <div class="small-point"></div>
                <div style="margin-left: 8px" class="info-text">年龄：</div>
                <div class="info-text-1">{{basicInfo.age || '--' }}</div>
              </div>
              <div style="display: flex;align-items: center">
                <div class="small-point"></div>
                <div style="margin-left: 8px" class="info-text">性别：</div>
                <div class="info-text-1">{{getSex(basicInfo.sex)}}</div>
              </div>
            </div>
            <div style="margin-left:50px">
              <div style="display: flex;align-items: center">
                <div class="small-point"></div>
                <div style="margin-left: 8px" class="info-text">监测账号：</div>
                <div class="info-text-1">{{basicInfo.monitorPhone}}</div>
              </div>
              <div style="display: flex;align-items: center">
                <div class="small-point"></div>
                <div style="margin-left: 8px" class="info-text">生成时间：</div>
                <div class="info-text-1">{{getCreateTime}}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 700px;overflow: scroll" class="chart-content">
          <div class="chart-title">{{item.day}} {{allDays}}</div>
          <div class="chart-border-2">
            <div class="chart-2">
              <div style="display:flex;margin-left:40px;margin-top:37px;align-items:center">
                <div style="width:5px;height:26px;background-color:#009CEE;">
                </div>
                <div class="chart2-title">
                  连续图谱
                </div>

                <div style="display:flex;align-items:center;background-color: rgba(0,156,238,0.05);border-radius: 14px;margin-left:65px;padding:4px 15px;">
                  <img src="../assets/img/mq_can_bi_icon.svg" style="width:15px;height:15px;" />
                  <div class="chart2-lengend">
                    参比
                  </div>
                  <img src="../assets/img/mq_eat_icon.svg" style="width:15px;height:15px;margin-left:18px" />
                  <div class="chart2-lengend">
                    饮食
                  </div>
                  <img src="../assets/img/mq_medicine_icon.svg" style="width:15px;height:15px;margin-left:18px" />
                  <div class="chart2-lengend">
                    用药
                  </div>
                  <img src="../assets/img/mq_work_out_icon.svg" style="width:15px;height:15px;margin-left:18px" />
                  <div class="chart2-lengend">
                    锻炼
                  </div>
                </div>

              </div>
              <div style="display:flex;align-items:center;margin-left:40px;margin-top:23px">
                <div style="display:flex;align-items:center;flex-direction:column">
                  <div class="blue-radius">
                    {{basicInfo.endSugar}}
                  </div>
                  <div style="font-size: 12px;font-weight: 400;color: #009CEE;line-height: 17px;margin-top:13px;margin-bottom:13px">
                    目标<br />范围
                  </div>
                  <div class="blue-radius">
                    {{basicInfo.startSugar}}
                  </div>
                </div>
                <div style="width: 1500px;height:300px;margin-top:0px" ref="preetydaysss" id='555666'></div>
              </div>
            </div>
            <div style="display:flex;justify-content:space-between;margin:34px 117px 0 117px ">
              <div class="chart-2-label-data">
                <div class="chart-number-2">{{item.avgSg}}</div>
                <div class="chart-unit-2">mmol/L</div>
                <div class="chart-des-2">血糖平均值</div>
              </div>
              <div class="chart-2-label-data">
                <div class="chart-number-2">{{item.highBlood}}</div>
                <div class="chart-unit-2">mmol/L</div>
                <div class="chart-des-2">血糖最高值</div>
              </div>
              <div class="chart-2-label-data">
                <div class="chart-number-2">{{item.lowBlood}}</div>
                <div class="chart-unit-2">mmol/L</div>
                <div class="chart-des-2">血糖最低值</div>
              </div>
              <div class="chart-2-label-data">
                <div class="chart-number-2">{{item.highPercent}}</div>
                <div class="chart-unit-2">%</div>
                <div class="chart-des-2">高血糖占比</div>
              </div>
              <div class="chart-2-label-data">
                <div class="chart-number-2">{{item.lowPercent}}</div>
                <div class="chart-unit-2">%</div>
                <div class="chart-des-2">低血糖占比</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import moment from 'moment'
import html2canvas from 'html2canvas'

export default {
  name: 'PrintDataPreView2',
  props:['itemData','basic'],
  data(){
    return {
      visible:false,
      bodyStyle: { top: '10px' },
      markPointData:[],
      chartData:[],
      basicInfo:this.basic,
      item: this.itemData,
      testForItems:[]
    }
  },
  computed:{
    getCreateTime:function(){
      return moment().format('YYYY-MM-DD HH:mm:ss');
    },
    allDays:function(){
      if(this.basicInfo.endDate == null){
        return "佩戴中"
      }
    },
    getId:function(){
      return this.item.day+this.basicInfo.monitorPhone
    },
  },
  mounted:function(){
    this.visible = true;
    this.$nextTick(()=>{
      this.handleDayChart(this.item)
    })
  },
  updated :function() {
    console.log('App.vue finish re-render')
  },
  methods: {
    getSex:function(sex){
      if(sex === '1' || sex === 1){
        return '男'
      }else if(sex === '2' || sex === 2){
        return '女'
      }else {
        return '--'
      }
    },
    handleCancel:function(){
      this.visible = false
    },

    close() {
      this.visible = false
    },
    handleDayChart(item){
      let that = this
      let chartDataDay = []
      let markPointDataDay = []
      for(let i = 0;i<item.rawDataBagsChartVOList.length;i++){
        chartDataDay.push([item.rawDataBagsChartVOList[i].recordDate,item.rawDataBagsChartVOList[i].machineBloodSugar])
        if(item.rawDataBagsChartVOList[i].eventList.length>0){
          for(let j = 0;j < item.rawDataBagsChartVOList[i].eventList.length;j++){
            if(item.rawDataBagsChartVOList[i].eventList[j].event_type === 1){
              let patientEvent = [item.rawDataBagsChartVOList[i].recordDate,item.rawDataBagsChartVOList[i].machineBloodSugar];
              let markPointGlucoseData = {
                coord:patientEvent,
                symbol: 'image://' + require('../assets/img/mq_can_bi_icon.svg'),
                symbolSize:'14'
              };
              markPointDataDay.push(markPointGlucoseData);
            }else if(item.rawDataBagsChartVOList[i].eventList[j].event_type === 2){
              let patientEvent = [item.rawDataBagsChartVOList[i].recordDate,item.rawDataBagsChartVOList[i].machineBloodSugar];
              let markPointEatFoodData = {
                coord:patientEvent,
                symbol: 'image://' + require('../assets/img/mq_eat_icon.svg'),
                symbolSize:'14'
              };
              markPointDataDay.push(markPointEatFoodData);
            }else if(item.rawDataBagsChartVOList[i].eventList[j].event_type === 3){
              let patientEvent = [item.rawDataBagsChartVOList[i].recordDate,item.rawDataBagsChartVOList[i].machineBloodSugar];
              let markPointMedicineData = {
                coord:patientEvent,
                symbol: 'image://' + require('../assets/img/mq_medicine_icon.svg'),
                symbolSize:'14'
              };
              markPointDataDay.push(markPointMedicineData);
            }else if(item.rawDataBagsChartVOList[i].eventList[j].event_type === 4){
              let patientEvent = [item.rawDataBagsChartVOList[i].recordDate,item.rawDataBagsChartVOList[i].machineBloodSugar];
              let markPointInsulinData = {
                coord:patientEvent,
                symbol: 'image://' + require('../assets/img/mq_insulin_icon.svg'),
                symbolSize:'14'
              };
              markPointDataDay.push(markPointInsulinData);
            }else if(item.rawDataBagsChartVOList[i].eventList[j].event_type === 5){
              let patientEvent = [item.rawDataBagsChartVOList[i].recordDate,item.rawDataBagsChartVOList[i].machineBloodSugar];
              let markPointWorkOutData = {
                coord:patientEvent,
                symbol: 'image://' + require('../assets/img/mq_work_out_icon.svg'),
                symbolSize:'14'
              };
              markPointDataDay.push(markPointWorkOutData);
            }

          }
        }
      }
      let precession = this.$refs.preetydaysss
      console.log(document.body.clientHeight)
      console.log(document.body.clientWidth)
      console.log(precession.style.height)
      console.log(precession.style.width)
      console.log(precession.clientHeight)
      console.log(precession.clientWidth)
      console.log(this.$refs.printDiv.clientHeight)
      let pd = that.$echarts.init(precession)
      let pdtion = {
        grid:{
          left:40,
          right:60,
          bottom:20,
          top:20
        },
        animation: false,
        tooltip: {
          show:false
        },
        xAxis: [{
          position:'bottom',
          type: 'time',
          axisLabel:{
            formatter: function (value,index) {
              // 格式化成月/日
              let a = moment(value).format("HH:mm")
              return '{gray|'+a+'}';
            },
            rich:{
              gray: {
                color: '#999999',
                fontSize: 12
              },
              blue:{
                color:'#1790FF',
                fontSize: 14,
                height:24,
                backgroundColor: 'rgba(23,144,255,0.05)',
                borderRadius: 5,
                padding:[0,10,2,10],
              }
            },
            textStyle:{
              color:'rgba(23,114,255,1)'
            },
          },
          axisLine:{
            show:true
          },
          interval:3600*1000,
          z:2
        },{
          position:'top',
          type: 'time',
          axisLabel:{
            show:false
          },
          axisLine:{
            show:true
          },
        }],
        yAxis:[{
          type: 'value',
          max:Math.ceil(that.basicInfo.highBlood*1.5),
          min:0,
          show: true,
          axisLabel:{
            show:true
          },
          splitLine:{
            show:false
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:"#999999"
            }
          }
        },{
          type: 'value',
          max:Math.ceil(that.basicInfo.highBlood*1.5),
          min:0,
          show: true,
          axisLabel:{
            show:false
          },
          splitLine:{
            show:false
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:"#999999"
            }
          }
        }],
        series:[
          {
            name: '血糖',
            type: 'line',
            data: chartDataDay,
            symbol:'none',
            itemStyle : {
              normal: {
                lineStyle: {
                  color: 'rgba(23,114,255,1)'
                }
              }
            },
            markPoint:{
              symbolSize:30,
              data:markPointDataDay,
              itemStyle:{
                color:'#FF5E5E'
              }
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#DCF3FE' // 0% 处的颜色
                }, {
                  offset: 1, color: '#FFFFFF' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            }
          },
        ]
      };
      pd.setOption(pdtion)

      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      html2canvas(this.$refs.printDiv).then(canvas => {
        // 转成图片，生成图片地
        that.$emit("showPhoto",canvas.toDataURL("image/png"));
        this.visible = false;
      }).catch(res =>{
        this.visible = false;
        console.log(res)
      });


    },

    //下载
    downloadFile(fileName, content) {
      let aLink = document.createElement('a');
      let blob = this.base64ToBlob(content); //new Blob([content]);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);

      // aLink.dispatchEvent(evt);
      aLink.click()
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },
  },
}
</script>
<style lang="less" scoped>
.card-container {
  background: #f5f5f5;
  overflow: hidden;
  padding: 24px;
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

.ant-tabs-nav-scroll {
  margin: auto;
  width: 300px;
}

.agp-container {
  border-style: solid;
  border-color: #5eaaf6;
  border-width: 1px;
}

.agp-title {
  background: #5eaaf6;
  color: white;
  padding-left: 5px;
}

.agp-box {
  margin-top: 30px;
  margin-left: 10px;
  margin-right: 10px;
}

.chartLabel {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 61px;
  font-size: 16px;
  color: #999999;
  letter-spacing: -0.32px;
  line-height: 22px;
}

.aaa {
  border-radius: 4px;
  border: 1px solid #1890ff;
  font-size: 15px;
  font-weight: 400;
  color: #1790ff;
}

.bbb {
  display: none;
}

.modalSty {
  background-color: yellow;
}
.modalSty .ant-modal-body {
  padding: 0px;
}
.modalSty .ant-modal-title {
  color: yellow;
  font-size: 15px;
  line-height: 5px;
}
.modalSty .ant-modal-close-x {
  width: 40px;
  height: 40px;
  color: green;
  line-height: 40px;
}
.info {
  background: #1790ff;
  border-radius: 17px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  line-height: 22px;
  padding: 5px 15px 5px 15px;
}
.rep-title {
  font-size: 32px;
  font-weight: 500;
  color: #000000;
  line-height: 45px;
}
.small-point {
  width: 6px;
  height: 6px;
  background: #1cafff;
  border-radius: 50%;
}
.info-text {
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  line-height: 27px;
}
.info-text-1 {
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 27px;
}
.chart-border {
  height: 987px;
  border-radius: 16px;
  border: 1px solid #999999;
  margin-top: -25px;
  position: relative;
}

.chart-border-2{
  height: auto;
  padding-bottom: 36px;
  border-radius: 16px;
  border: 1px solid #999999;
  margin-top: -25px;
  position: relative;
  overflow: scroll;
}

.chart-border-2::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.chart-content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.chart-title {
  width: 670px;
  height: 51px;
  background: #009cee;
  border-radius: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
  margin: 0 auto;
  z-index: 2;
  position: relative;
}

.chart-1 {
  display: flex;
}
.chart-1-label-data {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chart-2-label-data{
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
  border-radius: 30px;
  border: 1px solid #C2C2C2;
  padding: 17px 40px;
}

.chart-number {
  font-size: 66px;
  font-weight: 300;
  color: #333333;
  line-height: 92px;
}

.chart-number-2 {
  font-size: 56px;
  font-weight: 300;
  color: #009CEE;
  line-height: 78px;
}

.chart-number-1{
  font-size: 36px;
  font-weight: 300;
  color: #333333;
  line-height: 50px;
}

.chart-unit {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  line-height: 25px;
}

.chart-unit-2{
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 25px;
}


.chart-unit-1 {
  font-size: 12px;
  font-weight: 600;
  color: #999999;
  line-height: 17px;
  margin-top: 2px;
}

.chart-des {
  margin-top: 22px;
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
}

.chart-des-1{
  font-size: 15px;
  font-weight: 400;
  color: #666666;
  line-height: 21px;
  margin-top:9px;
}

.chart-des-2{
  margin-top:18px;
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
}

.chart2-title{
  font-size: 26px;
  font-weight: 500;
  color: #333333;
  line-height: 37px;
  margin-left: 11px;
}
.chart2-lengend{
  font-size: 15px;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  margin-left: 4px;
}
.blue-radius{
  background: #009CEE;
  border-radius: 10px;
  padding:0 8px;
  font-size: 15px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 21px;
}
.table-title{
  display:flex;
  align-items:center;
  justify-content: center;
  font-size: 22px;
  font-weight: 500;
  color: #666666;
}

.table-number{
  display:flex;
  align-items:center;
  justify-content: center;
  font-size: 22px;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
}

.table-number-print{
  display:flex;
  align-items:center;
  justify-content: center;
  font-size: 22px;
  font-weight: 400;
  color: #009CEE;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/PrintDataPreView2.vue